export enum NotificationType {
  default = "DEFAULT",
  warning = "WARNING",
  alert = "ALERT",
  disable = "DISABLE",
  success = "SUCCESS",
  info = "INFO"
}

export enum UserPreferenceType {
  DefaultFilterPreferences = "Default Filter Preferences"
}

export enum SearchResultType {
  RMSEvent = "RMSEvent",
  NIBINCaseData = "NIBINCaseData",
  FirearmData = "FirearmData",
  CrimeGunDetail = "CrimeGunDetail"
}

export enum VirtualGroupRelation {
  None = 0,
  Guest = 1,
  MyVirtualGroup = 2
}
